import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { submitFeedback } from '../services/feedbackApi';

const FeedbackForm = ({ questions = [], moduleId: propModuleId }) => {
  const { moduleId: paramModuleId } = useParams();
  const moduleId = propModuleId || paramModuleId;
  const { user } = useAuth();

  const [comments, setComments] = useState('');
  const [rating, setRating] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const questionsData = {};
    questions.forEach(q => {
        questionsData[q.id] = {
            text: q.text,
            type: q.type,
            answer: answers[q.id] !== undefined ? answers[q.id] : (q.type === 'boolean' ? false : '')
        };
    });

    const feedbackData = {
      userId: user.sub,
      exhibitionId: moduleId,
      comments: comments,
      rating: rating,
      questions: questionsData
    };

    try {
      await submitFeedback(feedbackData);
      setSubmitted(true);
    } catch (err) {
      setError('Failed to submit feedback. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAnswerChange = (id, value) => {
    setAnswers(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const buttonStyle = {
    background: '#D97706',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
    width: '100%'
  };

  if (submitted) {
    return (
      <div style={{fontFamily: 'Lato, sans-serif', textAlign: 'center'}}>
        <h2 style={{fontFamily: 'Playfair Display, serif', color: '#1F2937'}}>Thank you for your feedback!</h2>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="feedback-container" style={{fontFamily: 'Lato, sans-serif'}}>
      {/* <h2 style={{fontFamily: 'Playfair Display, serif', color: '#1F2937', marginBottom: '20px'}}>Feedback</h2>
       */}
      {questions && questions.length > 0 && (
        <div className="module-specific-questions" style={{ marginBottom: '20px', textAlign: 'left' }}>
            {questions.map((q, idx) => (
                <div key={q.id} style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333',  textTransform: 'capitalize' }}>{idx + 1}. {q.text}</label>
                    {q.type === 'boolean' ? (
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}><input type="radio" name={q.id} value="yes" checked={answers[q.id] === true} onChange={() => handleAnswerChange(q.id, true)} /> Yes</label>
                            <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}><input type="radio" name={q.id} value="no" checked={answers[q.id] === false} onChange={() => handleAnswerChange(q.id, false)} /> No</label>
                        </div>
                    ) : (
                        <textarea style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', minHeight: '80px' }} placeholder="Your answer..." value={answers[q.id] || ''} onChange={(e) => handleAnswerChange(q.id, e.target.value)}></textarea>
                    )}
                </div>
            ))}
        </div>
      )}

      <div className="star-rating" style={{ marginBottom: '20px' }}>
        {[...Array(5)].map((star, index) => {
          index += 1;
          return (
            <button
              type="button"
              key={index}
              className={index <= rating ? "on" : "off"}
              onClick={() => setRating(index)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '2rem', color: index <= rating ? '#ffc107' : '#e4e5e9' }}
            >
              <span className="star">&#9733;</span>
            </button>
          );
        })}
      </div>

      {(!questions || questions.length === 0) && <textarea
        value={comments}
        onChange={(e) => setComments(e.target.value)}
        placeholder="Enter your feedback here"
        rows="5"
        style={{width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc'}}
      />}
      <button type="submit" style={buttonStyle} disabled={loading}>
        {loading ? 'Submitting...' : 'Submit Feedback'}
      </button>
      {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
    </form>
  );
};

export default FeedbackForm;